import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import ExitIntentPopup from "./ExitIntentPopup";
import TranslationBanner from "./TranslationBanner";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-ivory text-charcoal flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <TranslationBanner />
        {children}
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ExitIntentPopup />
    </div>
  );
};

export default Layout;
